import React, { useState, useEffect } from 'react';

function StatusDropDown(props: any) {
    const [status, setStatus] = useState('Pending');
    const [clsName, setClsName] = useState('pending_cl');

    const clickHandle = (type: string) => {
        try {
            if (type == 'Pending') {
                setClsName('pending_cl');
            } else if (type == 'Verified') {
                setClsName('verified_cl');
            } else if (type == 'Rejected') {
                setClsName('rejected_cl');
            }
            props.updateStatus(props.item, type, props.item.id);
        } catch (error) {}
    };

    useEffect(() => {
        setStatus(props.item?.documents?.status);
    }, [props.item?.documents?.status]);

    return (
        <>
            <div
                className={`dropdown dropdown_status_box ${status === 'Rejected' ? 'inactive_status_box' : ''} ${
                    status === 'Pending' ? 'pending_status_box' : ''
                }`}
            >
                <button
                    className="btn btn-secondary dropdown-toggle capitalize"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    disabled={props.disabled ? props.disabled : false}
                >
                    {status}
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li>
                        <a
                            className={
                                props.item?.documents?.status === 'Pending' ? 'dropdown-item active' : 'dropdown-item'
                            }
                            href="javascript:void(0)"
                            onClick={() => {
                                props.updateStatus(props.item, 'Pending', props.item.id);
                            }}
                        >
                            Pending
                        </a>
                    </li>
                    <li>
                        <a
                            className={
                                props.item?.documents?.status === 'Verified' ? 'dropdown-item active' : 'dropdown-item '
                            }
                            href="javascript:void(0)"
                            onClick={() => {
                                props.updateStatus(props.item, 'Verified', props.item.id);
                            }}
                        >
                            Verified
                        </a>
                    </li>

                    <li>
                        <a
                            className={
                                props.item?.documents?.status === 'Rejected' ? 'dropdown-item active' : 'dropdown-item '
                            }
                            href="javascript:void(0)"
                            onClick={() => {
                                props.updateStatus(props.item, 'Rejected', props.item.id);
                            }}
                        >
                            Rejected
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
}

export default StatusDropDown;
